// src/config/RequireAuthRoute.jsx
// Zahtijeva samo prijavu (bez admin claims)

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../config/AuthProvider';

function RequireAuthRoute({ children }) {
  const { currentUser } = useContext(AuthContext);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default RequireAuthRoute;
